import { FlushError as e } from "./AmplitudeSink.mjs";
import { logger as t } from "./logger.mjs";
//#region src/core/FlushScheduler.ts
var n = 15e3, r = 50, i = 1e3, a = class {
	constructor(e, t, i) {
		this.queue = e, this.sink = t, this.timer = null, this.unbindLifecycle = null, this.flushing = !1, this.flushInterval = i.flushInterval ?? n, this.maxQueueSize = i.maxQueueSize ?? r, this.priority = new Set(i.priority ?? []), this.lifecycle = i.lifecycle;
	}
	start() {
		this.timer || (this.timer = setInterval(() => {
			this.flush().then(() => this.queue.touch());
		}, this.flushInterval), this.lifecycle && (this.unbindLifecycle = this.lifecycle.bind((e) => {
			this.flush({ terminal: e });
		})));
	}
	stop() {
		this.timer &&= (clearInterval(this.timer), null), this.unbindLifecycle &&= (this.unbindLifecycle(), null);
	}
	onEnqueue(e) {
		(this.priority.has(e) || this.queue.size() >= this.maxQueueSize) && this.flush();
	}
	isFlushingNow() {
		return this.flushing;
	}
	async flush(n = {}) {
		if (!this.flushing) {
			this.flushing = !0;
			try {
				for (;;) {
					let r = await this.queue.snapshot();
					if (r.length === 0) break;
					let a = r.slice(0, i);
					try {
						await this.sink.flush(a, { useBeacon: n.terminal }), await this.queue.remove(a), t.debug("flushed", a.length, "events");
					} catch (n) {
						if (!(!(n instanceof e) || n.retryable)) {
							await this.queue.remove(a), t.error("dropped non-retryable batch", a.length, n);
							continue;
						}
						t.warn("flush failed, will retry next cycle", n);
						break;
					}
				}
			} finally {
				this.flushing = !1;
			}
		}
	}
};
//#endregion
export { a as FlushScheduler };
